export const pageLeaveConfirmationFeatureName = 'pageLeaveConfirmation';
